import {Inject, Injectable, Optional} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../../util/codecs/encoder';

import {Observable} from 'rxjs';

import {environment} from '../../../../../environments/environment';
import {ApiService} from '../../util/api.service';
import {HeadersRequest} from '../../util/model/header-request.inteface';


@Injectable()
export class CartaService {

  private basePath = environment.basePathOrquestrador;

  constructor(protected apiService: ApiService, @Optional() @Inject('basePath') basePath: string) {
    if (basePath) {
      this.basePath = basePath;
    }
  }

  public consultarCarta(idOrdem: number, authorization?: string): Observable<any> {

    if (idOrdem === null || idOrdem === undefined) {
      throw new Error('Required parameter idOrdem was null or undefined when calling consultarCarta.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (idOrdem !== undefined) {
      queryParameters = queryParameters.set('idOrdem', <any>idOrdem);
    }

    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + authorization});

    const uri: string = environment.carta.consultarCarta;
    return this.apiService.get<any>(this.basePath + uri, queryParameters, headers);
  }

}
